<template>
  <div id="domain-placeholder">
    <router-view />
  </div>
</template>

<style>
  @import "assets/stylesheets/base.css";
</style>
